import type { CalculationSection } from '@features/glossary';
import type { TextProps, TextPropsTextConfig } from '@features/powerpoint';
import { calculationEntryV2 } from '../components/calculation-entry-v2';

export const getCalculationsV2 = (
  calculationItems: CalculationSection['items'],
  pagination: { perPage: number; page: number }
): TextProps => {
  const { perPage, page } = pagination;
  const itemsOnPage = Object.values(calculationItems).slice(
    page * perPage,
    (page + 1) * perPage
  );

  return {
    text: itemsOnPage.flatMap((item): TextPropsTextConfig[] => {
      const { label, definition } = item;

      const calculation: TextPropsTextConfig[] =
        item.calculationType === 'simple'
          ? [{ text: item.calculation, options: { breakLine: true } }]
          : Object.values(item.calculationByType).map(
              (c): TextPropsTextConfig => ({
                text: c,
                options: { breakLine: true },
              })
            );

      return [
        ...calculationEntryV2({ label, definition }),
        ...calculation,
        ...(item.additionalCalculations ?? []).map(
          (calculation): TextPropsTextConfig => ({
            text: calculation,
            options: { breakLine: true },
          })
        ),
      ];
    }),
  };
};
